import React from 'react'
import { GetBlueConicDomainIntegrationResponse } from '@pushly/models/lib/structs/domains'
import { PlatformIntegrationModal } from '../../../platform-integrations/platform-integration-modal/platform-integration-modal'
import { BlueConicLogo } from '../../../icons/blueconic-logo'
import { DisconnectOutlined, WarningFilled } from '@ant-design/icons'
import { Alert } from 'antd'

type BlueConicIntegrationRemoverProps = {
    modalStyle?: 'default' | '2025'
    source?: GetBlueConicDomainIntegrationResponse
    processing?: boolean
    onConfirm: (req: GetBlueConicDomainIntegrationResponse) => void
    onCancel: () => void
}

export const BlueConicIntegrationRemover: React.FC<BlueConicIntegrationRemoverProps> = (props) => {
    const name = props.source?.data?.name ?? 'BlueConic'

    return (
        <PlatformIntegrationModal
            className="blueconic-integration-remover"
            open={!!props.source}
            title="Remove Integration"
            titleIcon={<DisconnectOutlined />}
            providerLogo={<BlueConicLogo />}
            okText="Complete"
            onOk={() => props.onConfirm(props.source!)}
            okButtonProps={{ type: 'remove', loading: props.processing }}
            onCancel={props.onCancel}
        >
            <p>
                Removing the <b>“{name}”</b> integration will affect any Campaign that uses a “Send Recommended
                Notification” step linked to this integration. Associated steps will stop sending notifications, and
                users will automatically move to the next step in the Campaign.
            </p>

            <Alert type="error" icon={<WarningFilled />} showIcon={true} message="This action is not reversible" />
        </PlatformIntegrationModal>
    )
}
